var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcited(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13708_1805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 39.9989C31.0449 39.9989 39.9989 31.0449 39.9989 19.9995C39.9989 8.95407 31.0449 0 19.9995 0C8.95407 0 0 8.95407 0 19.9995C0 31.0449 8.95407 39.9989 19.9995 39.9989Z",
    fill: "#6EBF43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3686 19.6515C16.2483 19.7423 16.0868 19.7549 15.9549 19.6821C12.8012 17.9449 9.39322 18.8304 8.65442 18.9739C8.63014 18.9781 8.60692 18.9813 8.58265 18.9813C8.44017 18.9813 8.30718 18.899 8.24385 18.7671C8.14992 18.5729 8.27024 18.3924 8.43805 18.2562C8.98055 17.8182 12.5131 14.8598 16.4172 19.0858C16.5702 19.2526 16.5491 19.5154 16.3686 19.6515Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6312 19.6515C23.7515 19.7423 23.913 19.7549 24.0449 19.6821C27.1986 17.9449 30.6066 18.8304 31.3454 18.9739C31.3696 18.9781 31.3929 18.9813 31.4171 18.9813C31.5596 18.9813 31.6926 18.899 31.7559 18.7671C31.8499 18.5729 31.7295 18.3924 31.5617 18.2562C31.0192 17.8182 27.4867 14.8598 23.5826 19.0858C23.4296 19.2526 23.4507 19.5154 23.6312 19.6515Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.916 26.6387C12.916 26.6387 14.0664 31.7734 19.9991 31.7734C25.9317 31.7734 27.0821 26.6387 27.0821 26.6387H12.916Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13708_1805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcited);
export default __webpack_public_path__ + "static/media/excited.269043e911f7b3b991c90d1d1c65d37f.svg";
export { ForwardRef as ReactComponent };